import { render, staticRenderFns } from "./ViAdmissionAddTeacher.vue?vue&type=template&id=22f122ea"
import script from "./ViAdmissionAddTeacher.vue?vue&type=script&lang=js"
export * from "./ViAdmissionAddTeacher.vue?vue&type=script&lang=js"
import style0 from "./ViAdmissionAddTeacher.vue?vue&type=style&index=0&id=22f122ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports